export const SET_LANGUAGELIST = "SET_LANGUAGELIST";
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";
export const ADD_LANGUAGE = "ADD_LANGUAGE";
export const EDIT_LANGUAGE = "EDIT_LANGUAGE";
